import { createFileRoute } from '@tanstack/react-router';
import { OrgChartPage } from '@/features/org/org-chart-page';
import { guardRoute } from '@/lib/route-guards';

export const Route = createFileRoute('/_app/hr/org-chart')({
  beforeLoad: ({ context }) => {
    guardRoute(context.auth, '/hr/org-chart');
  },
  component: OrgChartPage,
});
